import React, {  useLayoutEffect } from 'react'
import { Navigate } from "react-router-dom";
import { UserAuth } from "../services/AuthContext";
import { getAuth } from "firebase/auth";

export const ProtectedRoutesBen = ({children})=>{
 const {user} = UserAuth();
 if (!user ){
     return <Navigate to='/login' />
   
 }
if(user && user.email=== 'benweber@nexointell.com'){
            return <Navigate to='/unfound2' />
           }
  
         

 

 return children
}